import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import config from '../../config';
import { subscribeRealtime } from '../../realtime';
import './finalizeBanner.css';

/**
 * Bandeau PERSISTANT « X à finaliser » (chantier finalisation livraisons).
 *
 * Constat proprio : les livreurs prennent en charge puis finalisent tard. Ce
 * bandeau rend l'encours URGENT (prise en charge sans résultat) impossible à
 * ignorer : non masquable tant que le compteur > 0, présent sur TOUT l'app
 * livreur (monté dans Layout2). Clic → onglet « En circulation » du hub, où l'on
 * déclare le résultat. Best-effort : masqué pendant un wizard (finalizeBanner.css
 * : body:has(.dw-cta)) pour ne pas recouvrir le CTA collant.
 *
 * Endpoint léger dédié (/mine/a-finaliser) + rafraîchi en temps réel (SSE famille
 * « livraisons ») pour disparaître dès le dernier résultat.
 */
export default function LivreurFinalizeBanner() {
  const navigate = useNavigate();
  const user = useSelector((s) => s.user.currentUser);
  const domain = config.REACT_APP_SERVER_DOMAIN;
  const token = user?.accessToken || user?.token || '';

  const [ouvertes, setOuvertes] = useState(0);
  const [heures, setHeures] = useState(0);

  const load = useCallback(async () => {
    if (!token) return;
    try {
      const r = await axios.get(`${domain}/api/mobile-delivery/mine/a-finaliser`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOuvertes(Number(r.data?.ouvertes || 0));
      setHeures(Number(r.data?.plus_ancienne_heures || 0));
    } catch (_) { /* silencieux : le bandeau ne doit jamais casser l'app */ }
  }, [domain, token]);

  useEffect(() => {
    load();
    const iv = setInterval(load, 90000);
    const onVisible = () => { if (document.visibilityState === 'visible') load(); };
    document.addEventListener('visibilitychange', onVisible);
    // Temps réel : toute évolution des livraisons peut clore un encours → recharge.
    const unsub = subscribeRealtime((payload) => {
      if (!payload || payload.famille === 'livraisons') load();
    });
    return () => {
      clearInterval(iv);
      document.removeEventListener('visibilitychange', onVisible);
      if (typeof unsub === 'function') unsub();
    };
  }, [load]);

  if (ouvertes <= 0) return null;

  return (
    <button
      type="button"
      className="liv-finalize-banner"
      onClick={() => navigate('/?scope=active')}
      aria-label={`${ouvertes} livraison(s) à finaliser`}
    >
      <span className="liv-finalize-banner__ic" aria-hidden="true">!</span>
      <span className="liv-finalize-banner__txt">
        <b>{ouvertes} livraison{ouvertes > 1 ? 's' : ''} à finaliser</b>
        {heures > 0 && <small>La plus ancienne ouverte depuis {heures} h</small>}
      </span>
      <span className="liv-finalize-banner__cta">Finaliser</span>
    </button>
  );
}
